/* eslint react/prop-types: 0 */
import { FormInput } from 'camino-react'
import { isEmpty } from 'lodash'
import React from 'react'
import Select from 'react-select'

const MissingAttributeCondition = ({
  update,
  predicates = []
}) => {
  const value = () => {
    if (isEmpty(predicates)) return []
    return options.filter(option => predicates.includes(option.value))
  }

  const handleUpdate = (e) => {
    const values = e.map(attribute => attribute.value)

    update(null, values)
  }

  const options = [
    { label: 'Assigne User', value: 'assignee_user_id' },
    { label: 'Client Contact', value: 'client_contact_id' },
    { label: 'Queue', value: 'queue_id' }
  ]

  return (
    <FormInput label="Attributes">
      <Select
        value={value()}
        options={options}
        onChange={e => handleUpdate(e)}
        multi
      />
    </FormInput>
  )
}

export default MissingAttributeCondition
